import isArray from 'lodash/isArray';
import { formatDate } from '@yme/components/Destinations/ExperienceGrid/components/ExperienceFilters/helpers';
import { MAP_LABEL_TO_FILTER_NAME } from '@yme/components/Destinations/ExperienceGrid/constants';
import { normalizeString } from '@yme/utils/common';
export function isExperienceGridEmpty() {
    return false;
}
export const getExperienceListingAnalyticsData = (data) => {
    return data.map((item) => ({
        destination: {
            id: normalizeString(item.edpURL
                .replace(/\/$/, '')
                .split('/')
                ?.at(-1)
                ?.replace(/^edp\.|\.html$/g, '')),
            title: item.title,
            country: item.location,
            category: isArray(item.typeLabelEn)
                ? item.typeLabelEn.map((l) => normalizeString(l)).join(', ')
                : normalizeString(item.typeLabelEn),
            level: item.levelLabelEn.map((l) => normalizeString(l)).join(', '),
            price: parseFloat(item.price.toFixed(2)),
            partner: normalizeString(item?.partnerReference?.partnerName),
            url: item.edpURL,
        },
    }));
};
export const mapTranslateToEn = (filtersConfig) => filtersConfig.reduce((acc, filter) => {
    filter.options.forEach((option) => {
        acc[option.label] = option.value;
    });
    return acc;
}, {});
export const getFilterAnalyticsData = (data, config) => {
    const mapping = mapTranslateToEn(config);
    const filterArray = Object.entries(data.filters).reduce((acc, [filterField, filterValue]) => {
        if (filterValue.length) {
            acc.push({
                filter: {
                    filterField: MAP_LABEL_TO_FILTER_NAME[filterField] || filterField,
                    filterValue: normalizeString(filterValue.map((value) => mapping[value] || value).join(';')),
                },
            });
        }
        return acc;
    }, []);
    const { from, to } = data.dateRange;
    const dateFilterValue = `${formatDate(from) || ''}${from && to ? ';' : ''}${formatDate(to) || ''}`;
    dateFilterValue &&
        filterArray.push({
            filter: {
                filterField: 'dateRange',
                filterValue: dateFilterValue,
            },
        });
    return filterArray;
};
